<h1 mat-dialog-title class="text-center mb-0 fw-bold mt-3">
    Add logo
</h1>

<mat-dialog-content>
    <div class="row mt-4">
        <button (click)="f_input.click()" mat-raised-button type="button">
            <span>Upload Logo</span>
            <mat-icon>upload</mat-icon>
        </button>
        <input multiple hidden #f_input type="file" accept="image/jpeg"
            (change)="handleFileInputChange(f_input.files!)">
    </div>
    <div class="row">
       <p class="text-center">For better results logo should have a size of 349 px by 1320 px</p>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="d-flex mt-1 justify-content-around">
    <button mat-dialog-close mat-raised-button class="w-25" color="warn" [disabled]="isLoading">Close</button>
    <button mat-raised-button class="w-25" [disabled]="isLoading || !fileSet"
        (click)="onSubmitForm()" color="primary">
        Add Logo
        <mat-spinner *ngIf="isLoading" [diameter]="30" [strokeWidth]="3" class="mx-auto mat-spinner"></mat-spinner>
    </button>
</mat-dialog-actions>